export default __webpack_public_path__ + "static/media/Manish .78c0de08.jpg";